var _feGaussianBlur;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShapeHomeplateShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 111,
    viewBox: "0 0 26.722916 29.368751",
    id: "svg20973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs20967"
  }, /*#__PURE__*/React.createElement("filter", {
    style: {
      colorInterpolationFilters: "sRGB"
    },
    id: "filter25243",
    x: -0.10199997,
    width: 1.2039999,
    y: -0.090666689,
    height: 1.1813334
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.8995832,
    id: "feGaussianBlur25245"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-267.63124)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 0.5,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950619,
      strokeOpacity: 1,
      filter: "url(#filter25243)"
    },
    d: "m 0,272.13583 22.217461,-10e-6 v 8.98916 L 11.108782,297.00004 0,281.12499 Z",
    id: "rect4518-85-9-8-1-0-9",
    transform: "matrix(0.99899425,0,0,0.99985756,2.2639011,-2.2117817)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShapeHomeplateShadow);
export default __webpack_public_path__ + "static/media/icon-shape-homeplate-shadow.9770fb83382b0fca80f06fbce2c39f53.svg";
export { ForwardRef as ReactComponent };